import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, TranslationProvider, utils } from '@resy/ui-kitchen';
import './TopNav.scss';
import { loadResyConfigThunk } from '../../../../../../ui-kitchen/src/reducers/resyConfigSlice';
import { IDLE } from '../../../../../../ui-kitchen/src/constants/asyncLoadingStatuses';
import appendCurrentQueryParams from '../../../utils/appendCurrentQueryParams';
import selectIsResyRewardsEnabled from '../../ResyRewards/selectors';

const CLICK_LINK_EVENT = 'click link';

const TopNav = ({
  Analytics,
  $rootScope,
  configStatus,
  countryCode,
  dispatch,
  isGdaEnabled,
  isResyRewardsEnabled,
}) => {
  const context = utils.getPageContext(window.location.pathname) ?? 'homepage';

  useEffect(() => {
    if (configStatus === IDLE) {
      dispatch(loadResyConfigThunk());
    }
  }, [configStatus, dispatch]);

  const handleLinkClick = async (label) => {
    await Analytics.event(CLICK_LINK_EVENT, {
      context,
      value: label,
    });
  };

  const amexOffersURL = 'https://www.americanexpress.com/en-us/credit-cards/offers/resy/?eep=46100&extlink=resy-homepage-nav-panel';
  const resyJoinUrl = appendCurrentQueryParams('https://resy.com/join/');

  return (
    <div className="TopNav">
      {$rootScope?.previewMode && <div className="TopNav--disabled" />}
      <div className="container TopNav__container">
        {countryCode === 'US' && (
          <>
            <TranslationProvider translationKey="footer.amex_offers">
              <Link
                onClick={() => {
                  handleLinkClick('header exclusive offers');
                }}
                href={amexOffersURL}
                resy-track-link="Clicked Exclusive U.S. Offers from Amex Link"
              >
                U.S. Card Offers from Amex
              </Link>
            </TranslationProvider>
          </>
        )}
        {isGdaEnabled && (
          <TranslationProvider translationKey="rga">
            <Link
              onClick={() => {
                handleLinkClick('header global dining access');
              }}
              href="/global-dining-access"
              resy-track-link="Clicked Global Dining Access Link"
            >
              Global Dining Access
            </Link>
          </TranslationProvider>
        )}
        {countryCode === 'US' && (
          <>
            <TranslationProvider translationKey="resy_credit">
              <Link
                onClick={() => {
                  handleLinkClick('header resy credit');
                }}
                href="/resycredit?intlink=us-resy-topnav"
                resy-track-link="Clicked the Resy Credit Link"
              >
                The Resy Credit
              </Link>
            </TranslationProvider>
          </>
        )}
        {isResyRewardsEnabled && (
          <TranslationProvider translationKey="resy_rewards">
            <Link
              onClick={() => {
                handleLinkClick('header resy rewards');
              }}
              href="/resy-rewards"
              resy-track-link="Clicked Resy Rewards Link"
            >
              Resy Rewards
            </Link>
          </TranslationProvider>
        )}
        <TranslationProvider translationKey="for_restaurants">
          <Link
            onClick={() => {
              handleLinkClick('header businesses');
            }}
            href={resyJoinUrl}
            target="_self"
            resy-track-link="Clicked For Businesses Link"
          >
            For Businesses
          </Link>
        </TranslationProvider>
      </div>
    </div>
  );
};

const topNavPropTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  $rootScope: PropTypes.shape({
    $on: PropTypes.func,
    previewMode: PropTypes.bool,
  }).isRequired,
  configStatus: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  isGdaEnabled: PropTypes.bool,
  isResyRewardsEnabled: PropTypes.bool,
};

TopNav.propTypes = topNavPropTypes;

TopNav.defaultProps = {
  countryCode: null,
  isGdaEnabled: false,
  isResyRewardsEnabled: false,
};

const mapStateToProps = (state) => ({
  configStatus: state.resyConfig.configStatus,
  isGdaEnabled: state.resyConfig.config?.enable_global_dining_access,
  isResyRewardsEnabled: selectIsResyRewardsEnabled(state),
  countryCode: state.user.userLocation?.countryCode,
});

TopNav.displayName = 'TopNav';

export { topNavPropTypes, TopNav as ComponentUnderTest, mapStateToProps };
export default connect(mapStateToProps)(TopNav);
